export default {
	TITLE: 'Operational Responsibilities',
	TABLE_FILTER_ACTIVE: 'Active',
	WORKPLACE_OPERATIONAL_RESPONSIBILITY_ADDED:
		'Workplace operational responsibility added!',
	WORKPLACE_TITLE: 'Workplaces',
};
